import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountEdit" })
export default class AccountEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public options: any = null;
    public editData: any = null;
    public formData: any = {};
    public validationErrors: any[] = [];

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await Promise.all([this.getOptions(), this.getData()]);
    }

    public async getOptions() {
        this.options = (await Axios.post(this.routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.Account_GetEditData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        this.formData.userName = this.editData.userName;
        this.formData.email = this.editData.email;
        this.formData.isNewsletterSubscriber = this.editData.isNewsletterSubscriber;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.Account_Edit, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            this.isSuccess = true;

            window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async removeExternal(loginProvider: string, providerKey: string) {
        let result = (await Axios.post(this.routes.AccountExternal_ExternalRemove, { loginProvider: loginProvider, providerKey: providerKey }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        window.location.href = this.routes.Account_Edit;
    }

    public async addExternal(loginProvider: string) {
        let result = (await Axios.post(this.routes.AccountExternal_ExternalLink + "?provider=" + loginProvider, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        window.location.href = this.routes.Account_Edit;
    }
};